import React, { Suspense } from "react";
import ViewPort from "../Editor/ViewPort";
import ModelInstanciator from "./ModelInstanciator";
import { ClientProvider } from "../../shared/hooks/client-hook";
import FPSControls from "./FPSControls";
import Sky from "../../shared/components/three/Sky";
import Sound from "./Sound";
import Loader from "./Loader";
import TVScreen from "./TVScreen";

const Viewer = () => {
  return (
    <ClientProvider>
      <div className="absolute top-0 right-0 left-0 bottom-0">
        <ViewPort onCreated={(gl) => {}}>
          <Suspense fallback={<Loader />}>
            <ModelInstanciator />
            <FPSControls />
            <Sound url="/sound/piano.mp3" position={[4.7, 2.2, -1.5]} />
            <TVScreen src={"/video/rocket.mp4"} position={[-1.65, 1.6, -2.59]} rotation={[0, 3.1416, 0]} scale={[0.9, 0.9, 0.9]} />
            <TVScreen src={"/video/purplereign.mp4"} position={[0.06, 1.59, 6.315]} rotation={[0, 3.1416/2, 0]} scale={[0.9, 0.9, 0.9]} />
            <ambientLight intensity={0.5} />
            <Sky />
          </Suspense>
        </ViewPort>
      </div>
    </ClientProvider>
  );
};

export default Viewer;
